// ---------------------------------------------
// Bold Text Parser - DeSight Shopify Theme
// ---------------------------------------------
// Parst **bold** Syntax im gesamten Theme
// Manipuliert ausschließlich Text-Nodes — kein innerHTML-Roundtrip
// ---------------------------------------------

import { $$ } from '../utils/helpers.js';

const SELECTORS = [
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  '.rte p', '.rte li', '.rte h1', '.rte h2', '.rte h3',
  '.content-wrapper p', '.content-wrapper h1', '.content-wrapper h2', '.content-wrapper h3',
  '.section-title', '.section-heading',
  '.card__heading', '.card__text',
  '.product__title', '.product__description',
  '.announcement-bar__message',
  '.footer__heading', '.footer__content'
];

const BOLD_REGEX = /\*\*(.+?)\*\*/g;

let observer = null;

function applyBoldToTextNodes(root) {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
  const nodesToProcess = [];
  let node;
  while ((node = walker.nextNode())) {
    BOLD_REGEX.lastIndex = 0;
    if (BOLD_REGEX.test(node.textContent)) {
      nodesToProcess.push(node);
    }
  }

  nodesToProcess.forEach((textNode) => {
    processTextNode(textNode);
  });
}

function processTextNode(textNode) {
  const parent = textNode.parentNode;
  if (!parent) return;

  const fragment = document.createDocumentFragment();
  const text = textNode.textContent;
  let lastIndex = 0;
  let match;
  const regex = new RegExp(BOLD_REGEX.source, BOLD_REGEX.flags);

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
    }

    const span = document.createElement('span');
    span.style.color = 'rgb(122, 185, 41)';
    span.textContent = match[1];
    fragment.appendChild(span);

    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
  }

  // Disconnect observer before DOM replacement to prevent re-entrant
  // MutationObserver callbacks that would re-scan the same nodes.
  if (observer) observer.disconnect();
  parent.replaceChild(fragment, textNode);
  if (observer) observer.observe(document.body, { childList: true, subtree: true });
}

function processElement(el) {
  if (el.dataset.boldParsed) return;
  applyBoldToTextNodes(el);
  el.dataset.boldParsed = 'true';
}

export function initBoldText() {
  SELECTORS.forEach((selector) => {
    $$(selector).forEach((el) => processElement(el));
  });

  observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        SELECTORS.forEach((selector) => {
          if (node.matches && node.matches(selector)) {
            processElement(node);
          }
          node.querySelectorAll(selector).forEach((el) => processElement(el));
        });
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}
